<template>
	<div class="product-list">
		<!--添加产品-->
		<!-- <div class="common-level-rail">
			<el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加技师</el-button>
		</div> -->
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<div>2222</div>
				<el-table size="small" :data="tableData" border style="width: 100%">
					<!-- v-loading="loading" -->
					<el-table-column prop="username" label="真实姓名" width="150px">
					</el-table-column>
					<el-table-column prop="gender" label="性别"></el-table-column>
					<el-table-column prop="birthday" label="生日"></el-table-column>
					<el-table-column prop="height" label="高度"></el-table-column>
					<el-table-column prop="introduce" label="个人介绍"></el-table-column>
					<el-table-column prop="nickName" label="昵称"></el-table-column>
					<el-table-column prop="mobile" label="电话号码"></el-table-column>
					<el-table-column prop="working_hours" label="工作时长"></el-table-column>
					<el-table-column prop="lng" label="经度"></el-table-column>
					<el-table-column prop="lat" label="纬度"></el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<el-button @click="editClick(scope.row)" type="primary" size="small">编辑商品</el-button>
								<!-- v-auth="'/product/product/edit'" -->
								<el-button @click="delClick(scope.row)" type="danger" size="small">删除商品</el-button>
								<!-- v-auth="'/product/product/delete'" -->
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber"></el-pagination>
		</div>
	</div>
</template>

<script>
	import Technician from '@/api/technician.js';
	// import Add from './Add.vue'
	export default {
		components: {
			// Add
		},
		data() {
			return {
				tableData: [],
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
			};
		},
		created() {
			/*获取列表*/
			this.getData()
		},
		methods: {
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.loading = true;
				self.curPage = val;
				self.getData();
			},
			/*每页多少条*/
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			/*打开添加*/
			addClick() {
				this.$router.push('/technician/technician/add');
			},
			getData() {
				let self = this
				let page = self.curPage;
				let pageSize = self.pageSize;
				Technician.getWaiter({
						page,
						pageSize
					}, true)
				.then(data => {
					let tableData = data.data.Waiter
					let tableDatas = data.data.Waiter.map((item,index) => {
						 item.gender = item.gender == 1 ? '男性' : '女性'
						 return item
					})
					self.tableData = data.data.Waiter
					self.totalDataNumber = data.data.total;
				})
				.catch(error => {
					// self.loading = false;
				});
			},
			/*打开编辑*/
			editClick(row) {
				console.log(row, '编辑技师')
			 this.$router.push({
					path: '/technician/technician/edit',
					query: {
						waiter_user_id: row.waiter_user_id,
						scene: 'edit'
					}
				});
			},
			/*删除*/
			delClick: function(row) {
				let self = this;
				self
					.$confirm('删除后将移动到回收站，确定删除该记录吗?', '提示', {
						type: 'warning'
					})
					.then(() => {
						Technician.deleteWaiter({
							waiter_user_id: row.waiter_user_id
						}).then(data => {
							self.$message({
								message: '删除成功',
								type: 'success'
							});
							self.getData();
						});
					});
			},
			// watch: {
			// 	tableData: {
			// 		handler(tableData) {
			// 			console.log(tableData)
			// 		},
			// 		immediate: true
			// 	}
			// }
		},
	}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/technician/index2.vue